import React from 'react';
import ModuleIcon from '../../Components/ModuleIcon';

export default function Glyph({ name, size = 18 }) {
    return (
        <span className="nova_glyph" aria-hidden="true">
            <ModuleIcon name={name} size={size} color="currentColor" />
        </span>
    );
}
